import { Search, X } from 'lucide-react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function CommandPalette() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault();
        setIsOpen(open => !open);
      }
      if (event.key === 'Escape') setIsOpen(false);
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-start justify-center px-4 pt-20" role="dialog" aria-modal="true" aria-label={t('Buscar comandos...')}>
      <div
        className="fixed inset-0 bg-black/50 backdrop-blur-sm"
        onClick={() => setIsOpen(false)}
      />
      <div className="relative w-full max-w-xl">
        <div className="overflow-hidden rounded-2xl border border-border bg-popover text-popover-foreground shadow-2xl">
          <div className="flex items-center border-b border-border px-4 py-3.5">
            <Search className="h-5 w-5 text-muted-foreground" />
            <input
              type="text"
              placeholder={t('Buscar comandos...')}
              className="ml-3 flex-1 bg-transparent text-foreground placeholder:text-muted-foreground focus:outline-none"
              autoFocus
            />
            <button
              onClick={() => setIsOpen(false)}
              className="ml-3 flex h-9 w-9 items-center justify-center rounded-lg text-muted-foreground hover:bg-accent hover:text-foreground"
              aria-label={t('Cerrar')}
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          <div className="max-h-96 overflow-y-auto py-2">
            <div className="px-4 py-5 text-center text-sm text-muted-foreground">
              {t('Presiona')}{' '}
              <kbd className="rounded-md border border-border bg-muted px-1.5 py-0.5 text-xs font-semibold text-foreground">
                Esc
              </kbd>{' '}
              {t('para cerrar')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
